// /components/reports/components/PeriodicOptions.js
import React from 'react';
import { Form, Stack } from 'react-bootstrap';
import {
  PERIODIC_REPORT_TYPES,
  PERIODIC_REPORT_TYPE_KEYS,
} from '../reportsEnums';

function PeriodicOptions({ periodicType, from, to, onChange }) {
  return (
    <Stack gap={3} className="p-2 border rounded">
      <Form.Label>Periodic Options</Form.Label>
      <Form.Group controlId="periodicTypeSelect">
        <Form.Label>Report Type</Form.Label>
        <Form.Select
          name="periodicType"
          value={periodicType}
          onChange={onChange}
        >
          <option value="">Choose...</option>
          {PERIODIC_REPORT_TYPE_KEYS.map((key) => (
            <option key={key} value={PERIODIC_REPORT_TYPES[key]}>
              {PERIODIC_REPORT_TYPES[key]}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group controlId="fromDate">
        <Form.Label>From Date</Form.Label>
        <Form.Control
          type="date"
          name="from"
          value={from}
          onChange={onChange}
        />
      </Form.Group>
      <Form.Group controlId="toDate">
        <Form.Label>To Date</Form.Label>
        <Form.Control type="date" name="to" value={to} onChange={onChange} />
      </Form.Group>
    </Stack>
  );
}

export default PeriodicOptions;